var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$fetchState.pending)?_c('skeleton-loader-page-head'):_c('div',[_c('crag-sector-page-header',{attrs:{"crag-sector":_vm.cragSector}}),_vm._v(" "),_c('v-container',{staticStyle:{"min-height":"100vh"}},[_c('nuxt-child',{attrs:{"crag-sector":_vm.cragSector}})],1),_vm._v(" "),_c('app-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }